import {
  getEmployeeProfileDefaultId,
  getEmployeeProfile,
} from '@api/company-policy/company-policy.service';
import { useQuery } from '@tanstack/react-query';

export const useEmployeesProfile = (id?: string) => {
  // For empty ID, we will get default profile and grab the ID
  const { isLoading: isDefaultProfileLoading, data: defaultProfile } = useQuery({
    queryKey: ['employee-profile-default-id'],
    queryFn: getEmployeeProfileDefaultId,
    enabled: !id,
  });

  const employeeProfileId = id || defaultProfile?.defaultCompanyPolicy;

  const { data, isLoading, refetch } = useQuery({
    queryFn: () => getEmployeeProfile(employeeProfileId || ''),
    queryKey: ['employee-profile', employeeProfileId],
    enabled: !!employeeProfileId,
  });

  return {
    isLoading: isDefaultProfileLoading || isLoading,
    refetchEmployeeProfile: refetch,
    employeeProfile: data,
  };
};
